











































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { GrantData, IGrant } from "@/entities";
// import ReportComponent from '../../Reports/Report.vue';
import HeaderInfo from '@/components/App/Modules/GMS/Grants/ExpansionPanel/ExpansionPanel.vue';


const namespace: string = "grant";

@Component({
    components: {
        HeaderInfo
    }
})
export default class CommunicationReports extends Vue {
    @Getter("readGrant", { namespace }) grant: IGrant;
    @Prop() grantId: number;
    @Prop() reports!: any;

    search: string = '';
    headers: any = [];
    editIcon = 'mdi-pencil-outline';
    title = 'Edit';

    /** mounted fn */
    mounted() {
        this.headers = this.$services.communication.reportCols;
        this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    /** format date */
    formatDate(dt: any) {
        return utils.formatDate(dt);
    }

    /** edit the selected item */
    editItem(item: any) {
        var commId = item.GrantCommunicationId.toString();
        this.$router.push({
            name: "communicationReports",
            params: { communicationId: commId },
            hash: `#${item.StepId}`
        });    
    }

}
